import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import { MainButton, BorderButton } from 'components/button'
import styles from './view.scss'

class CookiesNotSupported extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='title'>
					{localize('cookiesNotSupported_title')}
				</div>
				<div styleName='button'>
					<MainButton onClick={this.props.learnMore}>
						{localize('cookiesNotSupported_mainButton')}
					</MainButton>
				</div>
				<div styleName='subtitle'>
					{localize('cookiesNotSupported_subtitle')}
				</div>
				<div styleName='button'>
					<BorderButton
						onClick={this.props.retry}
						bgColor={'white'}
					>
						{localize('cookiesNotSupported_secondaryButton')}
					</BorderButton>
				</div>
			</div>
		)
	}
}

CookiesNotSupported.propTypes = {
	learnMore: PropTypes.func.isRequired,
	retry: PropTypes.func.isRequired,
}

export default CSSModules(CookiesNotSupported, styles, {allowMultiple: true})

